import queryString from 'query-string';
import React, { Fragment, useState, useEffect } from 'react';
import { NumberParam, useQueryParam, withDefault, ArrayParam } from 'use-query-params';
import Checkbox from '../../checkbox/Checkbox';
const PartnerItemsListingFilter = ({ partnerId }) => {
    const [selectedPage = 1, onSelectPage] = useQueryParam('page', withDefault(NumberParam, 1));
    const [selectedFilters, onSelectFilters] = useQueryParam('topics', withDefault(ArrayParam, []));
    const [data, setData] = useState(null);
    // Serialise for comparison check.
    const selectedFilterJson = JSON.stringify(selectedFilters);
    useEffect(() => {
        getData();
        async function getData() {
            const query = {
                page: selectedPage,
                topics: selectedFilters && [...selectedFilters],
            };
            // Use partner projects for tags list because all items are bound to them
            const res = await fetch(`/api/partnerproject/${partnerId}/load/?${queryString.stringify(query)}`);
            if (!res.ok) {
                return;
            }
            const resData = (await res.json());
            setData(resData);
        }
    }, [selectedFilterJson, selectedPage]);
    if (!data) {
        return null;
    }
    const filterPopulated = filterIsPopulated(data.filters);
    return (React.createElement(Fragment, null, filterPopulated ? (React.createElement("div", { className: `standard-banner standard-banner--sub site-wide` },
        React.createElement("div", { className: `grid-container grid-container--six` },
            React.createElement("div", { className: "grid-column form-orange" }, filterPopulated && data.filters && renderFilter('topics', data?.filters.topics))))) : null));
    function renderFilters(obj) {
        const keys = Object.keys(obj);
        return keys.map((filterKey) => {
            const filterObj = data?.filters.topics;
            if (!filterObj) {
                return null;
            }
            return renderFilter(filterKey, filterObj);
        });
    }
    function filterIsPopulated(obj) {
        const keys = Object.keys(obj);
        let length = 0;
        keys.map((filterKey) => {
            if (data?.filters.topics) {
                length = data?.filters.topics.filters.length;
            }
        });
        return length > 0;
    }
    function renderFilter(filterKey, filterObj) {
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: "checkboxes checkboxes--horizontal" },
                React.createElement(Checkbox, { data: filterObj.filters, name: filterKey, selectedFilters: selectedFilters, onChange: (event) => {
                        if (event.target instanceof HTMLInputElement) {
                            const currentItems = new Set(selectedFilters);
                            if (currentItems.has(event.target.value)) {
                                currentItems.delete(event.target.value);
                            }
                            else {
                                currentItems.add(event.target.value);
                            }
                            onSelectFilters([...currentItems], 'pushIn');
                            onSelectPage(1, 'pushIn');
                        }
                    } }))));
    }
};
export default PartnerItemsListingFilter;
